export const SET_FOCUSED_COLUMN_VIEW = "SET_FOCUSED_COLUMN_VIEW";
export const SET_EDITOR_VIEW_MODE = "SET_EDITOR_VIEW_MODE";
